import type { WebRunStep } from './runTypes';

export function isStepResolved(step: WebRunStep): boolean {
  return ['checkedYes', 'checkedNo', 'completed', 'denied'].includes(step.status);
}

export function isStepYes(step: WebRunStep): boolean {
  return step.status === 'checkedYes' || step.status === 'completed';
}

export function isStepNo(step: WebRunStep): boolean {
  return step.status === 'checkedNo' || step.status === 'denied';
}

export function stepNeedsNote(step: WebRunStep, outcome: 'yes' | 'no'): boolean {
  if (step.resolutionMode === 'execute') return false;
  return outcome === 'yes' ? step.checkYesRequireNote : step.checkRequireNote;
}

export function stepNeedsPhoto(step: WebRunStep, outcome: 'yes' | 'no'): boolean {
  if (step.resolutionMode === 'execute') {
    return outcome === 'yes' && step.requireProof !== false;
  }
  return outcome === 'yes' ? step.checkYesRequirePhoto : step.checkRequirePhoto;
}

export function stepNeedsEvidence(step: WebRunStep, outcome: 'yes' | 'no'): boolean {
  return stepNeedsNote(step, outcome) || stepNeedsPhoto(step, outcome);
}

export function stepComment(step: WebRunStep): string {
  const primary = step.resolutionMode === 'execute' ? step.note : step.details;
  return (primary || step.details || step.note || '').trim();
}

export function stepNoteRequiredForCurrent(step: WebRunStep): boolean {
  if (!isStepResolved(step)) return false;
  return stepNeedsNote(step, isStepNo(step) ? 'no' : 'yes');
}
